import { render, staticRenderFns } from "./SkrillFailed.vue?vue&type=template&id=0d5d78c4&"
import script from "./SkrillFailed.vue?vue&type=script&lang=js&"
export * from "./SkrillFailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports